import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'shared/components';
import NextPageIcon from 'assets/svgs/nextArrow.svg';

import './TaskCard.scss';

const TaskCard = props => (
  <div className="task-card" key={`task-${props.task.id}`}>
    <Card small={props.small} className={`${props.className} ${props.active ? 'active' : 'inactive'}`}>
      <div
        onClick={() => props.renderTask(props.task, props.active)}
        onKeyPress={(e) => e.key === 'Enter' ? props.renderTask(props.task, props.active) : e.preventDefault()}
        role="button"
        tabIndex="0"
        className='button-card-container'
      >
        <div className="card-content">
          {props.details && <div className="task-order-details">{props.details}</div>}
          <p className="text-strong mb-0">{props.task.name}</p>
        </div>
        <NextPageIcon />
      </div>
    </Card>
  </div>
);

export default TaskCard;

TaskCard.propTypes = {
  task: PropTypes.shape({}).isRequired,
  active: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  renderTask: PropTypes.func.isRequired,
  details: PropTypes.string,
  smallTaskCard: PropTypes.bool,
};
TaskCard.defaultProps = {
  small: true,
  active: false,
  className: '',
  smallTaskCard: false,
};
